import React, { useEffect, useState,useRef } from "react";
import axiosInstance from "./AxiosInstance"; // Import AxiosInstance
import ToastNotification from "./ToastNotification";
const Holidays = () => {
    const [holidays, setHolidays] = useState([]);
    const currentYear = new Date().getFullYear(); // Get current year
    const toastRef = useRef(null);
    useEffect(() => {
        const fetchHolidays = async () => {
            try {
                const response = await axiosInstance.get(`/common/holidays/${currentYear}`);
                setHolidays(response.data);
            } catch (error) {
                toastRef.current?.showToast("Error fetching holidays:","danger");
            }
        };

        fetchHolidays();
    }, [currentYear]);

    return (
        <div className="container mt-4">
            <h3 className="mb-3 text-center">Public Holidays - {currentYear}</h3>

            {/* Mobile view: scrollable */}
            <div className="table-responsive d-block d-md-none" style={{ maxHeight: "300px", overflowY: "auto" }}>
                <table className="table table-hover text-center align-middle table-striped">
                <thead className="table-primary">
                    <tr>
                    <th>#</th>
                    <th className="text-start">Date</th>
                    <th className="text-start">Day</th>
                    <th className="text-start">Description</th>
                    </tr>
                </thead>
                <tbody>
                    {holidays.length > 0 ? (
                    holidays.map((holiday, index) => {
                        const formattedDate = new Date(holiday.date).toLocaleDateString("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        });
                        return (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="text-start">{formattedDate}</td>
                            <td className="text-start">{holiday.weekday}</td>
                            <td className="text-start">{holiday.description}</td>
                        </tr>
                        );
                    })
                    ) : (
                    <tr>
                        <td colSpan="4" className="text-muted">No holidays found.</td>
                    </tr>
                    )}
                </tbody>
                </table>
            </div>

            {/* Desktop view: full table without scroll */}
            <div className="table-responsive d-none d-md-block">
                <table className="table table-hover text-center align-middle table-striped">
                <thead className="table-primary">
                    <tr>
                    <th>#</th>
                    <th className="text-start">Date</th>
                    <th className="text-start">Day</th>
                    <th className="text-start">Description</th>
                    </tr>
                </thead>
                <tbody>
                    {holidays.length > 0 ? (
                    holidays.map((holiday, index) => {
                        const formattedDate = new Date(holiday.date).toLocaleDateString("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        });
                        return (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="text-start">{formattedDate}</td>
                            <td className="text-start">{holiday.weekday}</td>
                            <td className="text-start">{holiday.description}</td>
                        </tr>
                        );
                    })
                    ) : (
                    <tr>
                        <td colSpan="4" className="text-muted">No holidays found.</td>
                    </tr>
                    )}
                </tbody>
                </table>
            </div>
            <ToastNotification ref={toastRef} />
        </div>
    );
};

export default Holidays;
